import { IForum, ISelectedTopic, IComment } from 'interface/forum';

const initialState: any = {
  selectedTopic: undefined as ISelectedTopic,
  editComment: null,
  comments: undefined as IComment,
  loader: true,
  err: false
};

const forum = (state: IForum = initialState, action: any) => {
  switch (action.type) {
    case 'SELECT_TOPIC': {
      return {
        ...state,
        selectedTopic: action.data
      };
    }

    case 'LOADER': {
      return {
        ...state,
        loader: true
      };
    }

    case 'LOAD_COMMENTS': {
      return {
        ...state,
        comments: action.comments,
        loader: false
      };
    }

    case 'SEND_COMMENT': {
      return {
        ...state,
        comments: {
          ...state.comments,
          data: [...state.comments.data, action.comment],
          total: state.comments.total + 1,
          to: state.comments.to + 1,
          from: state.comments.from > 0 ? state.comments.from : 1
        },
        loader: false
      };
    }
    case 'REMOVE_COMMENT_FORUM': {
      return {
        ...state,
        comments: {
          ...state.comments,
          data: state.comments.data.filter(c => c.id !== action.id),
          total: state.comments.total - 1,
          to: state.comments.to - 1,
          from: state.comments.to === 1 ? 0 : state.comments.from
        },
        loader: false
      };
    }
    case 'EDITING_COMMENT': {
      return {
        ...state,
        editComment: action.id
      };
    }
    case 'EDIT_COMMENT': {
      return {
        ...state,
        editComment: null,
        comments: {
          ...state.comments,
          data: state.comments.data.map(c => {
            // eslint-disable-next-line
            if (c.id == action.comment.id) {
              return action.comment;
            }
            return c;
          })
        },
        loader: false
      };
    }

    case 'MODERATE': {
      return {
        ...state,
        editComment: null,
        comments: {
          ...state.comments,
          data: state.comments.data.map(c => {
            // eslint-disable-next-line
            if (c.id == action.comment.id) {
              return action.comment;
            }
            return c;
          })
        }
      };
    }

    case 'ACTIVE_ERROR': {
      return {
        ...state,
        err: { hasError: true, statusError: action.statusError }
      };
    }
    default:
      return state;
  }
};

export default forum;
